import { OrderFillNowModel } from "app/bfx-order-fill-now/models/OrderFillNowModel";

export enum OrderFillNowCmd {
  RESET_MODEL,
  UPDATE_MODEL,
  CLEAR_MODEL,
  ACTION_RESPONSE,
}

export class OrderFillNowCmdPayload {
  constructor(
    public command: OrderFillNowCmd,
    public orderId: string,
    public payload?: OrderFillNowModel,
  ) {}
}
